import wx from 'weixin-js-sdk'
import axios from 'axios'
import urlConfig from '../config/urlConfig'
export default {
  async shareInit (obj, successCallback) {
    const res = await this.getWxConfig(obj)
    const jsApiList = [
      'updateTimelineShareData',
      'updateAppMessageShareData'
    ]
    const config = {
      debug: false,
      appId: res.data.appid,
      timestamp: res.data.timestamp,
      nonceStr: res.data.nonce,
      signature: res.data.signature,
      jsApiList: [...jsApiList] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    }

    // share拼接式参数url
    const shareLink = !obj.link ? res.data.url : obj.link
    // 钉钉内分享
    this.ddShareInit(obj, shareLink)

    wx.config(config)
    const shareData = {
      title: obj.title,
      desc: obj.desc,
      link: res.data.url,
      imgUrl: obj.imgUrl,
      success: (res) => {
        console.log('已分享')
        successCallback()
      },
      cancel: function (res) {
        console.log('已取消')
      },
      fail: function (res) {
        console.log(JSON.stringify(res))
      }
    }
    wx.ready(() => {
      jsApiList.forEach((item) => {
        wx[item](shareData)
      })
    })
  },
  ddShareInit (obj, shareLink) {
    dd.ready(function () {
      dd.biz.navigation.setRight({
        show: true, // 控制按钮显示， true 显示， false 隐藏， 默认true
        control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
        text: '更多', // 控制显示文本，空字符串表示显示默认文本
        showIcon: true, // 是否显示icon，true 显示， false 不显示，默认true； 注：具体UI以客户端为准
        onSuccess: function (result) {
          // 如果control为true，则onSuccess将在发生按钮点击事件被回调
          dd.biz.util.share({
            type: 0, // 分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
            url: shareLink, // 分享出去的；链接',
            content: obj.desc, // 分享出去的描述',
            title: obj.title, // 分享出去的标题',
            image: obj.imgUrl, // 分享出去的图标',
            onSuccess: function () {
              console.log('分享成功')
            },
            onFail: function (err) {
              console.log(err)
            }
          })
        },
        onFail: function (err) {
          console.log(err)
        }
      })
    })
  },
  async getWxConfig (obj) {
    const wxUrl = urlConfig.fafuliApiUrl() + 'wx/jsConfig?url=' + encodeURIComponent(obj.link)
    const res = await axios.get(wxUrl)
    return res
  }
}
